<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili
 */
import { computed } from "vue";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const props = defineProps<{
  data: any;
  link: string;
  delay: number;
  animate: boolean;
}>();

const devices = computed(() => props?.data?.image?.[0]?.devices);
</script>

<template>
  <router-link :to="link">
    <div class="project-box" :style="{ 'animation-delay': delay + 's' }" :class="{ 'project-box--animate': animate }">
      <div class="project-box__items">
        <div class="project-box__item">
          <div class="project-box__image-wrapper">
            <Picture class="project-box__image" :devices="devices" :alt="data?.title" />
          </div>
          <h2 class="project-box__caption hl-3-bold">
            {{ data?.title }}
          </h2>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss">
@keyframes slideFadeUp {
    from {
        transform: translateY(100px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.project-box {
  transform: translateY(100px);
  opacity: 0;

  &--animate {
      animation: 500ms slideFadeUp cubic-bezier(0.33, 1, 0.68, 1) forwards;
  }

  img {
    @include easeInOut(1200ms, all);
  }

  @include hover {
    img {
      transform: scale(1.1);
    }
  }

  &__items {
    background-color: $white;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid $brightGray;
    padding-bottom: 32px;
    @include maxq(mobile-sm) {
      margin-bottom: 0px;
    }
  }

  &__image-wrapper {
    width: 100%;
    transition: 0.5s all;
    position: relative;
    z-index: 1;
    margin-bottom: 32px;
    overflow: hidden;

    &::before {
      content: "";
      display: block;
      padding-top: 97.37903225806451%;
    }
  }

  &__caption {
    margin-left: 32px;
    @include clamp(2);
  }
}
</style>
